var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-array-prototype-extensions */
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
const EXTENSIONS = 'jpg,jpeg,png,gif';
const MAX_SIZE = 5 * 1e6;
let QAvatarInput = (_class = class QAvatarInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "strings", _descriptor, this);
    _initializerDefineProperty(this, "readFileError", _descriptor2, this);
    _defineProperty(this, "extensions", this.args.extensions || EXTENSIONS);
    _defineProperty(this, "maxSize", MAX_SIZE);
    _defineProperty(this, "showActions", !(this.args.showActions === false));
    _defineProperty(this, "handleAddAvatar", this.args.handleAddAvatar || (() => {}));
    _defineProperty(this, "handleDropAvatar", this.args.handleDropAvatar || (() => {}));
  }
  get avatarErrors() {
    let errors = this.args.errors || A([]);
    if (this.readFileError) {
      let localizedError = new Error(this.readFileError);
      return A([localizedError]);
    }
    if (errors.length > 0) {
      let hasManyErrorMessage = errors?.firstObject?.message?.firstObject;
      let singleErrorMessage = errors?.firstObject?.message;
      let localeMessage = hasManyErrorMessage || singleErrorMessage;
      let newErrors = new Error(localeMessage);
      return A([newErrors]);
    }
    return errors;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "strings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "readFileError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { QAvatarInput as default };